import Vue from 'vue';
export default Vue.extend({
    props: {
        input: Object
    },
    data: function () {
        return {
            files: [],
            maxAllowedFiles: 5,
            maxAllowedSize: 15
        };
    },
    methods: {
        onFileSelected: function (e) {
            var filesToAdd = Array.from(e.target.files);
            if (this.files.length + filesToAdd.length > this.maxAllowedFiles) {
                e.preventDefault();
                alert('Only up to 5 files allowed!');
            }
            else if (this.getFileSize(filesToAdd) > this.maxAllowedSize) {
                e.preventDefault();
                alert('Only up to 15mb allowed!');
            }
            else {
                this.files = filesToAdd;
            }
        },
        getFileSize: function (files) {
            return (files.reduce(function (acc, current) {
                return acc + current.size;
            }, 0) / 1000 / 1000);
        }
    },
    computed: {
        filesList: function () {
            if (this.files.length > 0) {
                return "".concat(this.files.length, " files selected (").concat(this.getFileSize(this.files).toFixed(3), " mb)");
            }
            return null;
        },
    },
});
